<template>
  <zj-layout-main :loading="loading">
    <div class="task_pop_bg">
      <!-- 标题 -->
      <div class="topSpot"></div>
      <div class="bottomSpot"></div>
      <div class="topBorder"></div>
      <div class="titleLine">
        <div class="info_title">
          <div class="titleLine_name">
            <span class="leftLine"></span
            ><span style="color: #2ac1ff">手动处理预警</span>
          </div>
          <div class="closeBtn" @click="closeMsgManual"></div>
        </div>
      </div>
      <div class="middleOutLine" id="msgContent" :loading="loading">
        <el-form :model="form" :rules="rules" ref="ruleForms">
          <div class="messageRow notisfy">
            <div class="circleType">{{ form.entityTypeTranslated }}预警</div>
            <div
              class="margin_0_10"
              :class="{
                redLevel: form.AlerteLevel === 10,
                orangeLevel: form.AlerteLevel === 7,
                yellowLevel: form.AlerteLevel === 5,
                blueLevel: form.AlerteLevel === 3,
              }"
            >
              {{ form.entityTypeTranslated }}{{ form.warnTypeTranslated }}
            </div>
          </div>

          <div class="notisfy">手动处理预警</div>
          <el-form-item>
            <el-upload
              action="#"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :http-request="uploadAvatar"
              :before-upload="beforeAvatarUpload"
              :file-list="fileList"
              accept="image/png, image/gif, image/jpg, image/jpeg"
            >
              <i class="addIcon"></i>
              <!-- <i slot="default" class="el-icon-plus"></i> -->
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <div style="margin-top: 30px">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </div>
            </el-dialog>
          </el-form-item>
          <el-form-item prop="processResult" label="处理结果">
            <el-input type="textarea" v-model="form.processResult"></el-input>
          </el-form-item>
          <el-form-item>
            <el-radio-group v-model="processWay" @change="changeWay">
              <el-radio label="经检查，为误报" border>经检查，为误报</el-radio>
              <el-radio label="已处理完毕" border>已处理完毕</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="msgfooter">
        <el-form :model="form" ref="ruleForm">
          <el-form-item
            style="margin-top: 10px; display: flex; justify-content: flex-end"
          >
            <el-button
              @click="submitForm('ruleForms')"
              style="margin-left: 15px"
              v-loading.fullscreen.lock="loading"
              >确认</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="bottomBorder"></div>
    </div>
  </zj-layout-main>
</template>
<script>
import { process } from "@/api/src/message";
import { uploadFile } from "@/api/src/file";
import waitAll from "@/utils/src/waitAll";
export default {
  data() {
    return {
      form: {},
      center: [],
      fileList: [],
      imgList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      fileImgList: [],
      loading: false,
      processWay: "",
      rules: {
        processResult: [
          { required: true, message: "请输入处理结果", trigger: "blur" },
        ],
      },
    };
  },
  props: {
    msgInfo: {
      type: Object,
      default: () => {},
    },
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  created: function () {
    if (this.isShow && this.msgInfo) {
      this.form = this.msgInfo;
    }
  },
  methods: {
    getDetails() {
      this.center = [];
      getMessageById(this.msgId).then((res) => {
        this.form = res.data;

        this.center.push(res.data.longitude);
        this.center.push(res.data.latitude);

        this.onDrawMap();
      });
    },
    //反写到处理结果中
    changeWay(val) {
      this.form.processResult = val;
    },
    closeMsgManual() {
      this.$emit("closeMsgManual", false);
    },
    onDrawMap: function () {
      let center = this.center;
      var map = new BMap.Map("allmapIndex");
      var point = new BMap.Point(center[0], center[1]);
      map.centerAndZoom(point, 12);
      var opts = { type: BMAP_NAVIGATION_CONTROL_SMALL };
      map.addControl(new BMap.NavigationControl(opts));
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    uploadAvatar(item) {
      this.imgList.push(item.file);
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      //this.$router.go(-1); //返回上一层
    },
    save() {
      this.loading = true;
      let that = this;
      if (this.imgList.length > 0) {
        //  that.uploadFile();
        //先上传图片
        that.uploadFile().then((r) => {
          that.saveData();
        });
      } else {
        that.saveData();
      }
    },
    // 上传文件
    uploadFile() {
      return new Promise((resolve, reject) => {
        let mediaList = this.imgList;
        var arr = [];
        mediaList.forEach((item) => {
          var formdata = new FormData();
          formdata.append("file", item);

          arr.push(this.upload(formdata));
        });

        waitAll(arr)
          .then((r) => {
            resolve(r);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    upload(formdata) {
      return uploadFile(formdata)
        .then((r) => {
          if (r.code == 200 && r.data) {
            let data = r.data;
            this.fileImgList.push(data);
          }
        })
        .catch((e) => {
          this.$message({
            type: "error",
            message: "上传失败，请重新上传",
          });
          console.log(e);
          //this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },

    saveData() {
      //已处理
      this.form.status = 1;
      this.form.uploadResouse = this.fileImgList.join(",");
      process(this.form)
        .then((r) => {
          r = r.code;
          this.$message({
            type: "success",
            message: r == 200 ? "处理成功！" : "处理失败！",
          });
          this.logInfo.ActionName = "消息手动处理";
          this.logInfo.LogMessage = r == 200 ? "消息处理成功" : "消息处理失败";
          this.logInfo.ModuleName = "消息";
          this.logInfo.PageName = "消息-待处理";
          this.addOperationLog();
          this.loading = false;
          this.closeMsgManual();
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          //this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
  },
};
</script>
<style scoped lang="scss">
.task_pop_bg {
  width: 36.5%;
  position: fixed;
  left: 50%;
  top: 120px;
  z-index: 99999;
  margin-left: -18.2%;
  box-sizing: border-box;
  border-bottom-left-radius: 22px;
  .topBorder {
    width: 100%;
    height: 34px;
    background: url("../../../../../../assets/pop_tz.png") no-repeat;
    background-size: 100% 34px;
    position: relative;
  }
  .bottomBorder {
    width: 100%;
    height: 25px;
    background: url("../../../../../../assets/pop_bz.png") no-repeat;
    background-size: 100%;
  }
  .titleLine {
    width: 100%;
    box-sizing: border-box;
    background: rgba(15, 36, 69, 1);
    border-left: 1px solid #2ac1ff;
    border-right: 1px solid #2ac1ff;
    padding-bottom: 10px;
    position: relative;
    .info_title {
      width: 92%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px dashed #2ac1ff;
      padding-bottom: 10px;
    }
    .titleLine_name {
      display: flex;
      align-items: center;
      .leftLine {
        display: inline-block;
        width: 2px;
        height: 15px;
        margin-right: 10px;
        background: #2ac1ff;
      }
    }
    .closeBtn {
      width: 20px;
      height: 20px;
      background: url("../../../theme-default/src/img/close.png") no-repeat;
      background-size: 20px;
      position: absolute;
      right: 20px;
      top: 0px;
      z-index: 20;
    }
  }
  .middleOutLine {
    height: 30.8rem;
    overflow: auto;
    width: 100%;
    padding: 0 10px;
    border-left: 0.5px solid #2ac1ff;
    border-right: 0.5px solid #2ac1ff;
    background: rgba(15, 36, 69, 1);
  }
  .notisfy {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 3%;
    font-size: 12px;
    margin-bottom: 15px;
  }
  .mapBox {
    width: 100%;
    height: 274px;
    padding: 24px 20px 16px 26px;
    box-sizing: border-box;
    position: relative;
  }
  .coverbg {
    // width: 525px;
    width: 100%;
    height: 274px;
    background: url("../../../../../../assets/mapborder.png") no-repeat;
    background-size: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
  }
  .topSpot {
    width: 222px;
    height: 125px;
    background: url("../../../../../../assets/spot.png") no-repeat;
    position: absolute;
    right: 15px;
    top: -62px;
    z-index: 1;
  }
  .bottomSpot {
    width: 222px;
    height: 120px;
    background: url("../../../../../../assets/spot.png") no-repeat;
    position: absolute;
    left: -35px;
    bottom: -45px;
    z-index: 10000;
  }
  .redLevel {
    color: #fb4d4e;
  }
  .yellowLevel {
    color: #fbda4e;
  }
  .blueLevel {
    color: #2ac1ff;
  }

  .circleType {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    font-size: 20px;
    color: #fff;
    line-height: 50px;
    text-align: center;
    background: #29bfff;
    overflow: hidden;
  }
  .messageRow {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .margin_0_10 {
    margin: 0 10px;
  }
  .margin_left {
    margin-left: 10rem;
  }
  .covermap {
    position: absolute;
    top: 37px;
    left: 50%;
    width: 86%;
    height: 77%;
    z-index: 2;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .msgfooter {
    height: 55px;
    width: 100%;
    padding: 10px 20px;
    border-left: 0.5px solid #2ac1ff;
    border-right: 0.5px solid #2ac1ff;
    background: rgba(15, 36, 69, 1);
    position: relative;
    z-index: 20;
  }
}
</style>
